module.exports = __webpack_public_path__ + "img/fuerza-popular.a19d4d99.png";